<template>
  <v-card flat height="350">
    <v-card-text style="height: 100%; padding-top: 0;">
      <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate></v-progress-circular>
      </v-overlay>

      <canvas v-show="data.length > 0" id="analyticSalesBarChart"> </canvas>

      <v-row v-show="data.length <= 0" align="center" justify="center">
        <v-icon small class="mr-1">fa-exclamation-circle</v-icon>
        <span>Pas de données pour la période sélectionnée</span>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import Chart from "chart.js";
import { mapGetters } from "vuex";
export default {
  name: "AnalyticEventsBarChart",
  props: {
    data: {
      type: Array,
      required: true
    },
    event: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  mounted() {
    this.createChart();
  },
  computed: {
    ...mapGetters(["getEvents"]),
    getEventList() {
      const list = this.getEvents.filter(x => x.name === this.event);
      return list.sort((a, b) => b.year - a.year);
    },
    getMergedSales() {
      const mergedSales = [];
      const group = this.data.map(x => {
        return x.sales;
      });
      group.forEach(x => {
        x.forEach(p => {
          mergedSales.push(p);
        });
      });
      return mergedSales;
    },
    getMaxDateListLength() {
      return Array.from(
        {
          length: Math.max(
            ...this.getEventList
              .map(x => this.getEventDateList(x))
              .map(x => x.length)
          )
        },
        (x, i) => i
      );
    }
  },
  data() {
    return {
      chart: undefined,
      showingYear: true,
      backgroundColor: [
        "#003f5c",
        "#2f4b7c",
        "#665191",
        "#a05195",
        "#EF9A9A",
        "#d45087",
        "#f95d6a",
        "#ff7c43",
        "#ffa600",
        "#D50000",
        "#D50000",
        "#F57C00"
      ]
    };
  },
  methods: {
    getEventDateList(event) {
      const dates = [];

      let currDate = moment(event.start);
      const lastDate = moment(event.end);

      while (currDate.diff(lastDate) <= 0) {
        dates.push(currDate.clone().toDate());
        currDate.add(1, "days");
      }

      return dates;
    },
    getEvent(year) {
      return this.getEventList.find(x => x.year === year);
    },
    getSales(event, index) {
      if (event) {
        const eventDateList = this.getEventDateList(event);
        if (eventDateList.length >= index) {
          const eventDate = eventDateList[index];
          const sales = this.getMergedSales.find(x =>
            moment(x.date).isSame(moment(eventDate))
          );
          if (sales) {
            return sales.sales;
          } else {
            return 0;
          }
        }
      } else {
        return 0;
      }
    },
    createChart() {
      const ctx = document.getElementById("analyticSalesBarChart");
      this.chart = new Chart(ctx, {
        type: "bar",
        data: {
          datasets: this.data.map((d, i) => {
            return {
              label: d.year,
              data: this.getMaxDateListLength.map(x => {
                return {
                  y: this.getSales(this.getEvent(d.year), x),
                  x: `${x + 1} journée`
                };
              }),
              backgroundColor: this.backgroundColor[i]
            };
          }),
          labels: this.getMaxDateListLength.map(x => `${x + 1} journée`)
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          barValueSpacing: 1,
          legend: {
            display: false
          },
          tooltips: {
            mode: "label",
            callbacks: {
              label: function(t, d) {
                var dstLabel = d.datasets[t.datasetIndex].label;
                var yLabel = t.yLabel;
                return `${dstLabel}: ${yLabel}$`;
              }
            }
          },
          scales: {
            gridLines: {
              color: "rgba(0, 0, 0, 0)"
            },
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                },
                gridLines: {
                  color: "rgba(0,0,0,0)",
                  display: false
                }
              }
            ],
            xAxes: [
              {
                offset: true,
                gridLines: {
                  offsetGridLines: false,
                  zeroLineColor: "rgba(0,0,0,0)",
                  color: "rgba(0,0,0,0)"
                },
                ticks: {
                  display: false
                }
              }
            ]
          }
        }
      });
    },
    updateChart() {
      this.chart.data.datasets = this.data.map((d, i) => {
        return {
          label: d.year,
          data: this.getMaxDateListLength.map(x => {
            return {
              y: this.getSales(this.getEvent(d.year), x),
              x: `${x + 1} journée`
            };
          }),
          backgroundColor: this.backgroundColor[i]
        };
      });
      this.chart.update();
    }
  },
  watch: {
    loading() {
      this.updateChart();
    },
    event() {
      this.updateChart();
    }
  }
};
</script>

<style lang="scss" scoped></style>
